<script lang="ts" setup>
import {
  ControlProxy,
  setProxy,
  setProxyMethods,
  type Component,
  type Control,
  type ShowFormParameters,
  type Slot,
} from "@/global";

import { computed, inject, provide, reactive, ref, type Ref } from "vue";

const props = defineProps<{ component: Component }>();
provide("component", props.component);
const showParams = inject<ShowFormParameters>(
  "showParams"
) as ShowFormParameters;
const index = inject<Ref<number> | undefined>("index", undefined);
const pIndex = inject<Ref<number> | undefined>("pIndex", undefined);

const ctrlRef = ref();
const proxy = reactive(
  new ControlProxy(
    showParams,
    props.component.key,
    props.component.control,
    ctrlRef
  )
);
proxy.init();
setProxyMethods(props.component.control.type, proxy);
setProxy(
  showParams.pageId,
  props.component.key +
    (pIndex !== undefined ? `_${pIndex.value}` : "") +
    (index !== undefined ? `_${index.value}` : ""),
  proxy
);

const slots = computed<Slot[]>(() => {
  const control = props.component.control as Control;
  if (!control.slots) return [];
  return Object.entries(control.slots).reduce<Slot[]>(
    (arr, [name, components]) => {
      if (components.length > 0) {
        arr.push({ name, components });
      }

      return arr;
    },
    []
  );
});

provide("proxy", proxy);
</script>

<template>
  <component
    :is="proxy.tag"
    v-show="proxy.props.visible !== false"
    ref="ctrlRef"
    v-bind="proxy.props"
    v-on="proxy.handlers"
  >
    <template v-for="slot in slots" :key="slot.name" #[slot.name]>
      <ComponentRender
        v-for="cmp in slot.components"
        :key="cmp.uid"
        :component="cmp"
      />
    </template>
  </component>
</template>
